import { Getter, State, Action, Mutation } from 'vuex-class'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CircleProgress from '@/components/circleProgress/circleProgress'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import { parseProducts } from '@/plugins/json_products_parser'
import ModalCashbackRequest from '@/components/modalCashbackRequest/modalCashbackRequest'

@Component({
  components: {
    CircleProgress,
    SkeletonFluid,
    ModalCashbackRequest
  }
})
export default class Tracker extends Vue {

  // Getters
  @Getter getCurrentOrder: any
  @Getter getOrderPayment: any;
  @Getter getCountry: any
  @Getter getIsUnderMobile: any
  @Getter getOpenCart: any
  @Getter getOpenCashbackModal: any
  @Getter getOrdersWithCoupons: any
  @Getter getIsXLScreen: any

  // Mutations
  @Mutation OPEN_CART
  @Mutation OPEN_CASHBACK_MODAL
  @Mutation CURRENT_ORDER

  isReady = true;
  showOrderSummary = false;
  showMap = false;
  hasCoupon = false;
  showOrderModifications = false;

  // Map
  positionMarker = {}
  renderMap = false
  mapOptions = {
    center: { lat: 4.701, lng: -74.05 },
    zoom: 16,
    fullscreenControl: false,
    mapTypeControl: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    zoomControl: false,
    draggable: false,
    scrollwheel: false
  }

  markerOptions = {
    position: { lat: 4.701, lng: -74.05 },
    title: 'Marker A',
    draggable: false
  }

  get hasUpdatedOrder() {
    return this.getCurrentOrder.order_updates && this.getCurrentOrder.order_updates.length;
  }

  get getGroupedProducts() {
    let response = [];
    
    if(this.getCurrentOrder && this.getCurrentOrder.json_products) {
      const jsonProducts = [...this.getCurrentOrder.json_products];

      if(jsonProducts && jsonProducts.length) {
        for(let i=0; i < jsonProducts.length; i++) {
          let count = 1;
          const product1 = jsonProducts[i];
          for(let j=i+1; j < jsonProducts.length; j++) {
            const product2 = jsonProducts[j];
            if(product1.product_id === product2.product_id) {
              count++;
            }
          }          
          const productObj = {...product1, quantity: count};
          const isIndex = response.findIndex((item) => item.product_id === productObj.product_id);
          if(isIndex === -1) {
            response.push(productObj);
          }
        }
      }
    }
    return response;
  }

  mounted() {
    if (this.getCurrentOrder.latitude != null) {
      this.mapOptions.center.lat = parseFloat(this.getCurrentOrder.latitude);
      this.mapOptions.center.lng = parseFloat(this.getCurrentOrder.longitude);

      this.markerOptions.position.lat = this.getCurrentOrder.latitude;
      this.markerOptions.position.lng = this.getCurrentOrder.longitude;

      this.renderMap = true
    } else {
      this.renderMap = false
    }
    this.onCurrentOrderChange();
  }

  get getOrderNewProducts() {
    let response = [];
    if (
      this.getCurrentOrder &&
      this.getCurrentOrder.new_products &&
      this.getCurrentOrder.new_products.length &&
      this.getCurrentOrder.json_products &&
      this.getCurrentOrder.json_products.length
    ) {
      const newProductsIds = this.getCurrentOrder.new_products;
      const orderProducts = this.getCurrentOrder.json_products;
      orderProducts.map((product) => {
        const index = newProductsIds.findIndex((id) => id === product.product_id);
        if(index !== -1) {
          response.push(product);
        }
      });
    }
    return response;
  }

  get getParsedProducts() {
    const parsedProducts = parseProducts(this.getCurrentOrder.json_products);
    return parsedProducts;
  }

  get getOpenCartComputed() {
    if (this.getIsUnderMobile) {
      return this.getOpenCart;
    }
    return true;
  }

  get getIsTerminalStatus() {
    let response = false;
    if (this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response =
        status === "troubleshooting_restaurant" ||
        status === "order_not_generated" ||
        status === "order_canceled_by_restaurant" ||
        status === "order_canceled_in_handoff" ||
        status === "troubleshooting_hand_off";
    }
    return response;
  }

  get getIsFinished() {
    let response = false;
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response = status === "order_completed";
    }
    return response;
  }

  get getOrderStatusLabel() {
    let response = "";
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      switch (status) {
        case "waiting_restaurant_confirmation":
          response = "Recibida";
          break;
        case "waiting_for_external_payment":
          response = "Esperando pago externo";
          break;
        case "preparing_order":
        case "waiting_pickup_deliveryman":
        case "already_restaurant":
          response = "Alistando";
          break;
        case "delivering_order" : 
          response = "En camino"
          break;
        case "troubleshooting_restaurant":
        case "order_canceled_by_restaurant":
          response = "Cancelada"
          break;
        case "order_completed": 
          response = "Entregada"
          break;
      }
    }
    return response;
  }

  get getOrderStatusColor() {
    let response = "";
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      switch (status) {
        case "waiting_restaurant_confirmation":
          response = "#329ACF";
          break;
        case "waiting_for_external_payment":
          response = "#ffdf5f";
          break;
        case "preparing_order":
        case "waiting_pickup_deliveryman":
        case "already_restaurant":
          response = "#9BFB9A";
          break;
        case "delivering_order" : 
          response = "#9BFB9A"
          break;
        case "troubleshooting_restaurant":
        case "order_canceled_by_restaurant":
          response = "#CC0001"
          break;
        case "order_completed": 
          response = "#00F303"
          break;
      }
    }
    return response;
  }

  getPaymentTypeIcon() {
    let response = "";
    if(this.getCurrentOrder && this.getCurrentOrder.payment_type) {
      const payment = this.getCurrentOrder.payment_type;
      switch(payment) {
        case "credit_card": 
          response = "ion-card"
          break;
        case "payment_link":
          response = "ceu-icon-share"
          break;
        case "pse":
          response = "/assets/images/ui/pse.png"
          break;
        case "cash":
          response = "ion-cash"
          break;
      }
    }
    return response;
  }

  get getPaymentTypeLabel() {
    let response = "";
    if(this.getCurrentOrder && this.getCurrentOrder.payment_type) {
      const payment = this.getCurrentOrder.payment_type;
      switch(payment) {
        case "credit_card": 
          response = "Tarjeta de crédito"
          break;
        case "payment_link":
          response = "Link de pago"
          break;
        case "pse":
          response = "PSE"
          break;
        case "cash":
          response = "Efectivo"
          break;
      }
    }
    return response;
  }

  _money(val) {
    const price = parseFloat(val)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  discount() {
    let total = (this.getCurrentOrder.total - this.getCurrentOrder.delivery_price) * 0.07;
    total = total >= 0 ? total: 0;
    return total
  }

  goToPay() {
    if(this.getCurrentOrder && this.getCurrentOrder.payment_link && this.getCurrentOrder.payment_link.length) {
      if (this.getCurrentOrder.instance_currency === 'MXN') {
        window.open(`https://pay.conekta.com/link/${this.getCurrentOrder.payment_link}`, '_blank');
      } else {
        window.open(`https://checkout.wompi.co/l/${this.getCurrentOrder.payment_link}`, '_blank');
      }
    }
  }
  // _openIntercom() {
  //   (window as any).Intercom('show')
  // }

  _closeTracker() {
    this.$emit('close');
  }

  _openChat() {
    // TODO
  }

  _onToggleMap() {
    this.showMap = !this.showMap;
    if(this.showMap) {
      try {
        const element = document.getElementById('map');
        element.scrollIntoView();
      } catch (error) {
        // Do Nothing!
      }
    }
  }

  _openTyC() {
    window.open('/files/TYC_Atrevete_a_Probar.pdf');
  }

  _toggleModalCashback() {
    const open = this.getOpenCashbackModal;
    this.$emit('cashback-modal', !open);
  }

  @Watch('getCurrentOrder', { deep: true })
  onCurrentOrderChange() {
    this.showMap = false;
    if(this.getOrdersWithCoupons && this.getOrdersWithCoupons.length && this.getCurrentOrder.id >= 0) {
      const index = this.getOrdersWithCoupons.findIndex((item) => item === this.getCurrentOrder.id);
      this.hasCoupon = index !== -1;
    }
    this.renderMap = false;
    this.positionMarker = {
      lat: this.getCurrentOrder.latitude,
      lng: this.getCurrentOrder.longitude
    }
    this.mapOptions.center = { lat: this.getCurrentOrder.latitude, lng: this.getCurrentOrder.longitude };
    this.renderMap = true;
  }

  _toggleModifications() {
    if(this.getCurrentOrder.order_updates && this.getCurrentOrder.order_updates.length) {
      this.showOrderModifications = !this.showOrderModifications;
    } else {
      this.showOrderModifications = false;
    }
  }
}